import { cva, type VariantProps } from 'class-variance-authority';
import React from 'react';

import { cn } from '../../../lib/utils';

const colorVariants = cva('text-muted-foreground', {
  variants: {
    variant: {
      foreground: 'text-foreground',
      muted: 'text-muted-foreground',
      primary: 'text-primary',
      secondary: 'text-secondary',
      accent: 'text-accent',
      destructive: 'text-destructive',
      'gray-600': 'text-gray-600',
    },
  },
  defaultVariants: {
    variant: 'gray-600',
  },
});

export interface MedicationPillIconProps
  extends React.SVGProps<SVGSVGElement>, VariantProps<typeof colorVariants> {
  size?: number | string;
}

export const MedicationPillIcon = React.forwardRef<
  SVGSVGElement,
  MedicationPillIconProps
>(function MedicationPillIcon(
  { className, style, size, width, height, variant, ...rest },
  ref,
) {
  const w = width ?? size ?? 30;
  const h = height ?? size ?? 31;
  const colorClass = colorVariants({ variant });
  return (
    <svg
      ref={ref}
      width={w}
      height={h}
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('stroke-current', colorClass, className)}
      style={{ ...(style as React.CSSProperties) }}
      {...rest}
    >
      <rect y="0.379883" width="30" height="30" rx="6" fill="currentColor" />
      <path
        d="M21.4428 6.36662C19.7694 4.91036 17.2323 5.08638 15.776 6.75978L6.98673 16.8596C5.53047 18.533 5.7065 21.0701 7.3799 22.5264C9.45402 24.3314 11.9464 23.3975 13.5362 21.5706C13.0599 20.7447 12.7874 19.7865 12.7874 18.7646C12.7874 15.658 15.3058 13.1396 18.4124 13.1396C19.1572 13.1396 19.8681 13.2843 20.5186 13.5472L21.836 12.0334C23.2922 10.36 23.1162 7.82288 21.4428 6.36662Z"
        fill="white"
      />
      <path
        d="M14.4898 14.733C13.4921 13.9108 12.705 12.8589 11.8209 11.3047L6.98673 16.8596C5.53047 18.533 5.7065 21.0701 7.3799 22.5264C9.45402 24.3314 11.9464 23.3975 13.5362 21.5706C13.0599 20.7447 12.7874 19.7865 12.7874 18.7646C12.7874 17.1836 13.4397 15.7549 14.4898 14.733Z"
        fill="white"
      />
      <path
        d="M6.98673 16.8596L15.776 6.75978C17.2323 5.08638 19.7694 4.91036 21.4428 6.36662C23.1162 7.82288 23.2922 10.36 21.836 12.0334L20.5186 13.5472C19.8681 13.2843 19.1572 13.1396 18.4124 13.1396C15.3058 13.1396 12.7874 15.658 12.7874 18.7646M6.98673 16.8596C5.53047 18.533 5.7065 21.0701 7.3799 22.5264C9.45402 24.3314 11.9464 23.3975 13.5362 21.5706C13.0599 20.7447 12.7874 19.7865 12.7874 18.7646M6.98673 16.8596L11.8209 11.3047C12.705 12.8589 13.4921 13.9108 14.4898 14.733C13.4397 15.7549 12.7874 17.1836 12.7874 18.7646"
        stroke="currentColor"
        strokeWidth={1.2}
      />
      <path
        d="M19.4927 7.49853C18.0432 7.12459 17.1643 8.13458 16.7248 8.63957"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
      />
      <path
        d="M24.0371 18.7646C24.0371 21.8713 21.5187 24.3896 18.4121 24.3896C15.3055 24.3896 12.7871 21.8713 12.7871 18.7646C12.7871 15.658 15.3055 13.1396 18.4121 13.1396C21.5187 13.1396 24.0371 15.658 24.0371 18.7646Z"
        fill="white"
        stroke="currentColor"
        strokeWidth={1.2}
      />
      <path
        d="M14.6089 19.7837L22.2156 17.7455"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
      />
    </svg>
  );
});

MedicationPillIcon.displayName = 'MedicationPillIcon';
